import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-403294f8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "jxTab",
  cellspacing: "0"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "平一"), /*#__PURE__*/_createElementVNode("th", null, "平二"), /*#__PURE__*/_createElementVNode("th", null, "平三"), /*#__PURE__*/_createElementVNode("th", null, "平四"), /*#__PURE__*/_createElementVNode("th", null, "平五"), /*#__PURE__*/_createElementVNode("th", null, "平六"), /*#__PURE__*/_createElementVNode("th", null, "特码")])], -1));
const _hoisted_4 = {
  class: "numTr"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("table", _hoisted_2, [_hoisted_3, _createElementVNode("tbody", null, [_createElementVNode("tr", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, i) => {
    return _openBlock(), _createElementBlock("th", {
      key: i
    }, [_createElementVNode("div", {
      class: _normalizeClass($options.getCss(item.num))
    }, _toDisplayString(item.num), 3)]);
  }), 128))]), _createElementVNode("tr", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, i) => {
    return _openBlock(), _createElementBlock("th", {
      key: i
    }, _toDisplayString(item.sx), 1);
  }), 128))]), _createElementVNode("tr", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, i) => {
    return _openBlock(), _createElementBlock("th", {
      key: i
    }, _toDisplayString(item.wx), 1);
  }), 128))])])]), _createElementVNode("div", {
    class: "jxBtn",
    onClick: _cache[0] || (_cache[0] = $event => $options.jxStart())
  }, "开始机选"), _createElementVNode("div", {
    class: "jxBtn",
    onClick: _cache[1] || (_cache[1] = $event => $options.copy())
  }, "复制结果")]);
}